/**
 * The live copy of the /docs page: `docsCopy` is a LIVE BINDING (`export let`) that
 * points at the Slovenian set (docsCopySl.ts) or, on /cz/docs, the Czech set
 * (docsCopyCs.ts) — set ONCE per page load by DocsPage.initialize through
 * `setDocsLanguage`. Every renderer reads `docsCopy.…` at call time, so a switch
 * before the first render is all it takes; none captures a string at module load.
 *
 * Deliberately NOT `utils/i18n.ts` (`setLanguage` / `detectLanguage`): that module
 * writes `localStorage.gsx8_language`, which the map pages read — a visit to
 * /cz/docs must not flip the map into Czech.
 */

import type { WikiCountry } from '../../shared/types/layerWiki.js';
import { docsCopyCs } from './docsCopyCs.js';
import { docsCopySl, type DocsCopy } from './docsCopySl.js';

export type { DocsCopy };
export { docsCopyCs, docsCopySl };

/** The two chrome languages (the `lang` of <html> on the page). */
export type DocsLanguage = 'sl' | 'cs';

let current: DocsLanguage = 'sl';

// eslint-disable-next-line import/no-mutable-exports -- a live binding by design (see the header)
export let docsCopy: DocsCopy = docsCopySl;

export function setDocsLanguage(lang: DocsLanguage): void {
  current = lang;
  docsCopy = lang === 'cs' ? docsCopyCs : docsCopySl;
}

export function getDocsLanguage(): DocsLanguage {
  return current;
}

/** The chrome language of a /docs half: Czech on /cz/docs, Slovenian on /si/docs. */
export function docsLanguageFor(country: WikiCountry): DocsLanguage {
  return country === 'cz' ? 'cs' : 'sl';
}
